import UsersService from "@/services/common/UsersService";

const getters =
{
	isGlobalAdministrator:  state => UsersService.IsGlobalAdmin(state.user.role),
	isCompanyAdministrator: state => UsersService.IsCompanyAdmin(state.user.role),
	isDemo:                 state => UsersService.IsDemo(state.user.role),
	userCompanyId:          state => state.user.companiesId,
};

export default { getters };
